import fetcher from '../fetcher'

import type { Document, DocumentType } from './types'
import config from '../../config'
import { IResponseBody } from '../types'

export const getAllDocuments = async (): Promise<Array<Document>> => {
	try {
		const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/documents`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
		console.error(`Error fetching documents: ${error}`)
		throw error
	}
}

export const getLastDocuments = async (maxItems: number): Promise< Array<Document>> => {
	try {
		const urlParams = new URLSearchParams({limit: maxItems.toString()})
		const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/documents/last?${urlParams}`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching documents: ${error}`)
		throw error
	}
}

export const getRelatedDocuments = async (documentId: number, maxItems: number): Promise< Array<Document>> => {
	try {
		const urlParams = new URLSearchParams({limit: maxItems.toString()})
		const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/documents/related/${documentId}?${urlParams}`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching documents: ${error}`)
		throw error
	}
}

export const getAllDocumentTypes = async (): Promise<Array<DocumentType> | undefined> => {
	try {
		const res: IResponseBody<Array<DocumentType>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/documents/types`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching document types: ${error}`)
		throw error
	}
}

export const getDocumentById = async ({ id }: { id: string }): Promise<Document | undefined> => {
	const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/documents/${id}`, { method: 'GET' })
	return res.data
}

export const bookmarkDocument = async (_: string[], { arg }: { arg: { documentId: string, saved: boolean } }) => {
	await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/document/${arg.documentId}/bookmark`, { method: 'POST', body: JSON.stringify({ saved: arg.saved }) })
}

export const getBookmarkedDocuments = async (): Promise<Document[] | undefined> => {
	const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/document/bookmarks`, { method: 'GET' })
	return res.data
}
